export const SOURCES = {
  PRODUCT_PAGE: 'productPage',
  RECOMMENDATION_API: 'recommendationApi',
}

export const STATUSES = {
  ADDING_TO_CART: 'addingToCart',
  ADDED_TO_CART: 'addedToCart',
  FETCHING: 'fetching',
  FETCHED: 'fetched',
  ERROR_FETCHING: 'errorFetching',
  ERROR_ADDING_TO_CART: 'errorAddingToCart',
}
